const AlertSyncStatus = ({ isConnected, isDataStale, hasAlerts, connectionError }) => {
    if (!isDataStale && isConnected) {
        return null;
    }

    let title = 'Reconnecting live alerts';
    let body = 'Live alert updates are reconnecting. New alarm changes may take a moment to appear.';
    let alertClassName = 'alert alert-secondary border shadow-sm mb-3';

    if (isDataStale && hasAlerts) {
        title = 'Showing last known alerts';
        body = 'Live alert updates were interrupted. The alerts below may be out of date until the connection and refresh complete.';
        alertClassName = 'alert alert-warning border shadow-sm mb-3';
    } else if (isDataStale) {
        title = 'Live alert updates interrupted';
        body = 'The alert connection is recovering and a fresh alarm snapshot is being requested.';
        alertClassName = 'alert alert-warning border shadow-sm mb-3';
    }

    return (
        <div className={alertClassName} role={'status'} aria-live={'polite'}>
            <div className={'fw-bold'}>{title}</div>
            <div className={'small mb-0'}>
                {body}
                {connectionError ? ` (${connectionError})` : ''}
            </div>
        </div>
    );
};

export default AlertSyncStatus;
